import { FC } from 'react';

import { Skeleton, Tr } from '@bonusly/design-system';

import { TableData } from './incentives-table';

interface SkeletonTableRowsProps {
	numberOfRows: number;
}

export const SkeletonTableRows: FC<SkeletonTableRowsProps> = ({ numberOfRows }) => {
	return (
		<>
			{[...Array(numberOfRows).keys()].map((index) => {
				const isLast = index === numberOfRows - 1;
				return (
					<Tr key={index} data-testid="skeleton-table-rows">
						<TableData isLast={isLast}>
							<Skeleton h={6} w="75%" />
						</TableData>
						<TableData isLast={isLast}>
							<Skeleton h={6} w="80%" />
						</TableData>
						<TableData isLast={isLast}>
							<Skeleton h={6} w="75%" />
						</TableData>
						<TableData isLast={isLast}>
							<Skeleton h={6} w="85%" />
						</TableData>
						<TableData isLast={isLast}>
							<Skeleton h={6} w="90%" />
						</TableData>
						<TableData isLast={isLast}>
							<Skeleton h={6} w="85%" />
						</TableData>
						<TableData isLast={isLast}>
							<Skeleton h={6} w="75%" />
						</TableData>
					</Tr>
				);
			})}
		</>
	);
};
